import React, { useState, useEffect } from 'react';
import Modal                          from 'react-bootstrap/Modal';
import CloseBtn                       from 'assets/icons/Close.svg';
import ListOptionsBtn                 from 'assets/icons/List Options.svg';
import DownloadBtn                    from 'assets/icons/Download.svg';
import Search                         from 'assets/icons/Search.svg';

export function AssistantClaimsFilters(props) {
  const handleClose       = () => setShow(false);
  const handleShow        = () => setShow(true);
  const [show, setShow]   = useState(false);

  // Selecting status
    const [status, setStatus] = useState('');

    const selectStatus = (value) => {
      setStatus(status !== value ? value : '');
    }

    const statuses = [
      { name: 'Pending Submission', value: 'not_submitted' }, // Has value of not_submitted, under_review & draft.
      { name: 'Approved',           value: 'approved' },
      { name: 'Rejected',           value: 'rejected' },
      { name: 'Pending Approval',   value: 'pending_approval' } // Has value of pending & under_approval_review.
    ];

    const statusButtons = statuses.map((hash, index) => {
      const btnColor = status.includes(hash.value) ? 'btn-outline-danger bg-faintred' : 'btn-outline-disabledgrey';

      return(
        <button key={ index } className={ "btn rounded-pill px-6 py-3 mr-3 mb-3 " + btnColor } onClick={() => selectStatus(hash.value) }>{ hash.name }</button>
      )
    });

  // Selecting sorting order
    const [sorting, setSorting] = useState(props.sorting);

    const selectSorting = (value) => {
      setSorting(sorting !== value ? value : '');
    }

    const sortCategories = [
      { name: 'Date',         value: 'date' },
      { name: 'Doctor Name',  value: 'drname' }
    ];

    const sortingButtons = sortCategories.map((hash, index) => {
      const btnColor    = sorting.includes(hash.value) ? 'btn-outline-danger bg-faintred' : 'btn-outline-disabledgrey';

      return(
        <button key={ index } className={ "btn rounded-pill px-6 py-3 mr-3 mb-3 " + btnColor } onClick={() => selectSorting(hash.value) }>{ hash.name }</button>
      )
    });

  // Selecting doctor & filter search term
    const [doctor, setDoctor]         = useState('');
    const [searchTerm, setSearchTerm] = useState('');
    const doctorList                  = props.locations;

    const selectDoctor = (value) => {
      setDoctor(doctor !== value ? value : '');
    }

    const filterDrButtons = () => {
      const lowerTerm       = searchTerm.toLowerCase();
      var clinicDrHash      = {};
      var displayDrButtons  = [];

      // Organize doctors by locations/
      doctorList.forEach((hash) => {
        const drAndClinic = hash.doctor + ' ' + hash.location;

        if (lowerTerm.length === 0 || drAndClinic.toLowerCase().includes(lowerTerm)) {
          var arrayList = clinicDrHash[hash.location] || [];
          arrayList.push(hash);
          clinicDrHash[hash.location] = arrayList;
        }
      });

      // Insert them into array by title and buttons.
      Object.keys(clinicDrHash).sort().forEach((key) => {
        displayDrButtons.push(
          <p key={ key } className="font-size-7"><b>{ key }</b></p>
        );

        clinicDrHash[key].forEach((hash, index) => {
          var btnColor = doctor === hash.id ? 'btn-outline-danger bg-faintred' : 'btn-outline-disabledgrey';

          displayDrButtons.push(
            <button key={ hash.id } className={ "btn rounded-pill px-6 py-3 mr-3 mb-3 " + btnColor } onClick={() => selectDoctor(hash.id) }>
              <p className="mb-0 mx-1"><b>{ hash.doctor }</b></p>
            </button>
          );
        });
      });

      return displayDrButtons;
    }

    const [drButtons, setDrButtons] = useState(filterDrButtons());

    useEffect(() => {
      setDrButtons(filterDrButtons());
    }, [searchTerm, doctorList, doctor]); // eslint-disable-line react-hooks/exhaustive-deps

  // Apply Button
    const [applyBtn, setApplyBtn] = useState(<span></span>);

    useEffect(() => {
      const applyFilters = () => {
        props.changeFilters(status, doctor, sorting);
        setShow(false);
      }

      setApplyBtn(
        <button className="btn rounded-pill btn-danger w-em-26 py-3" onClick={() => applyFilters() }>Apply</button>
      );
    }, [status, doctor, sorting]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div>
      <img src={ DownloadBtn } alt="list-options-btn" className="mr-4 clickable w-em-7" data-placement="top" title="Download Excel" onClick={() => props.downloadCsv() } />
      <img src={ ListOptionsBtn } alt="list-options-btn" className="mr-4 clickable w-em-7" onClick={ handleShow } />

      <Modal show={ show } onHide={ handleClose } keyboard={ false } dialogClassName="modal-70w" centered>
        <Modal.Header>
          <Modal.Title>Filter</Modal.Title>

          <button type="button" className="close" onClick={ handleClose }>
            <img src={ CloseBtn } alt="modal-close" />
          </button>
        </Modal.Header>

        <Modal.Body>
          <div className="mb-3">
            <h6 className="modal-section-header px-4 py-3 my-6">Select Status</h6>
            { statusButtons }
            <h6 className="modal-section-header px-4 py-3 my-6">Sort By</h6>
            { sortingButtons }
            <h6 className="modal-section-header px-4 py-3 my-6">Select Doctor/Facility</h6>

            <div className="search-box mb-6" style={{ width: '100%' }}>
              <img src={ Search } alt="search-icon" id="search-icon" />

              <input
                type="text"
                placeholder="Search for doctor/facility"
                className="form-control rounded-pill"
                id=""
                value={ searchTerm }
                onChange={(e) => setSearchTerm(e.target.value) }
              />
            </div>

            { drButtons }

            <div className="mt-8 text-center">
              { applyBtn }
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
}